import React from 'react';
import SuiteIcons from '~envs/assets/suite_icon.png';
import { SuiteId } from '~/constants';
import { corpUserStore } from '~/models';

interface SuiteIconProps {
    className?: string;
    suiteId: number;
    size?: number;
}

const suiteIconIndexMap = new Map([
    [SuiteId.APP_BUILDER, 0],
    [SuiteId.ANALYTICS, 1]
]);

const SuiteIcon: React.FC<SuiteIconProps> = (props) => {
    const { className, suiteId, size = 48 } = props;
    const iconUrl = corpUserStore.getSuiteModuleById(suiteId)?.icon_url;

    const style = iconUrl
        ? {
              backgroundImage: `url(${iconUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              width: size,
              height: size
          }
        : {
              backgroundImage: `url(${SuiteIcons})`,
              backgroundPositionX: -(suiteIconIndexMap.get(suiteId) || 0) * size,
              backgroundSize: `${size * 5}px ${size}px`,
              width: size,
              height: size
          };

    return <div className={className} style={style} />;
};

export default SuiteIcon;
